import { ISelectValue } from '.';

export const createSimpleSelectOption = (optionValue: string, optionLabel?: string): ISelectValue => ({
  label: optionLabel ?? optionValue,
  value: optionValue
});
